<template>
  <div>
    <header :class="{'menu-open': isMenuOpen}">
      <div class="container">
        <div class="row">
          <div class="col header-col">
            <div class="logo">
              <router-link to="/" v-if="!isHome"><img src="../assets/skyline-logo-black.svg" alt="Skyline" /></router-link>
            </div>
            <button class="menu-toggle" aria-label="Open the Menu" v-on:click="toggleMenu">
              <span class="bars" aria-hidden="true"></span>
            </button>
            <nav>
              <ul>
                <li><a href="https://skylineconference.co/about">About</a></li>
                <li><router-link to="#" class="btn btn-primary disabled" id="eventbrite-header" v-on:click.prevent="trackClick">Register</router-link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      isHome: false,
      isMenuOpen: false,
    }
  },
  watch: {
    '$route': {
      handler: function (to) {
        // determine whether or not to show the opaque header
        this.isHome = to.name == 'Home'

        // close the mobile menu on page change
        if (this.isMenuOpen == true) {
          this.isMenuOpen = false
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * Open and close the mobile menu
     */
    toggleMenu: function () {
      this.isMenuOpen = !this.isMenuOpen
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/variables";

header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  transition: background-color 250ms;
  border-bottom: 1px solid #DEDEDE;
  background-color: white;
}

div.header-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
}

div.logo {
  img {
    width: 169px;
    height: auto;
  }
}

button.menu-toggle {
  padding: 10px;
  width: 52px;
  height: 52px;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  perspective: 80px;
  position: relative;
  z-index: 12;
  display: none;

  @media all and (max-width: $mobileMax) {
    display: block;
  }

  span.bars {
    display: block;
    width: 100%;
    height: 3px;
    background-color: white;
    position: relative;
    transition: transform .15s cubic-bezier(.645,.045,.355,1),background-color 0s cubic-bezier(.645,.045,.355,1) .1s;
    background-color: black;

    .menu-open & {
      background-color: transparent !important;
      transform: rotateY(180deg);
    }

    &:before,
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background-color: white;
      position: absolute;
      left: 0;
      transition: transform 0s cubic-bezier(.645,.045,.355,1) .1s;
      background-color: black;
    }

    &:before {
      top: -10px;

      .menu-open & {
        transform: translate3d(0,10px,0) rotate(45deg);
      }
    }

    &:after {
      bottom: -10px;

      .menu-open & {
        transform: translate3d(0,-10px,0) rotate(-45deg);
      }
    }
  }

  &:active,
  &:focus {
    outline: none;
  }
}

nav {
  @media all and (max-width: $mobileMax) {
    position: fixed;
    width: 100%;
    top: 0;
    right: 100%;
    bottom: 0;
    background-color: $pink;
    z-index: 11;
    transition: right 250ms ease-in;

    .menu-open & {
      right: 0;
    }
  }

  ul {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    margin: 0;

    @media all and (max-width: $mobileMax) {
      flex-direction: column;
      padding-top: 2em;
    }

    li {
      a {
        color: white;
        font-size: 16px;
        font-weight: 600;
        display: block;
        transition: color 250ms;

        &:not(.btn) {
          padding: 4px 3px;
          margin: 0 15px;
          border-bottom: 3px solid transparent;
          color: black;

          &:hover,
          &.router-link-exact-active {
            border-bottom: 3px solid $pink;
            text-decoration: none;
          }
        }

        &.btn {
          text-transform: uppercase;
          font-size: 14px;
          padding: 0.5rem 1rem;
          margin-left: 20px;

          &.disabled {
            filter: grayscale(1);
          }
        }

        @media all and (max-width: $mobileMax) {
          &.btn,
          &:not(.btn) {
            font-size: 24px;
            line-height: 3;
            color: white;

            &:hover,
            &.router-link-exact-active {
              border-bottom: none;
              text-decoration: none;
            }
          }
        }

        span.live {
          display: inline-block;
          background-color: $green;
          color: black;
          font-weight: 700;
          font-size: 12px;
          line-height: 14px;
          padding: 2px 4px;
          margin: 0 0 0 6px;
          position: relative;
          top: -2px;
        }
      }
    }
  }
}
</style>
